module.exports = [


{
  
        "id": "1",
        "courseTitle": "HTML",
        "CourseModule":[
          {
            "id":"2",
            "moduleTitle": "Introduction to HTML",
            // "moduleSubTitle": ["Introduction to Web", "Getting started with HTML", "Document Structure", "Element Tags & Attributes", "Creating New Page"],
            "moduleSubtitle": ["Introduction to Web", "Getting started with HTML", "Document Structure", "Element Tags & Attributes", "Creating New Page" ]
          },

          {
            "id":"3",
            "moduleTitle": "Symentic Structure",
            "moduleSubtitle": ["Nesting of tags", "Links images & Lists", "Symentic structure in HTML", "Inline Element", "Table" ]
          },

          {
            "id":"4",
            "moduleTitle": "User interfaces & Typography",
            // "moduleSubTitle": ["Heading fonts & colors", "white spaces symbols & Char set", "Entities & icons", "Video & Audio" ],
            "moduleSubtitle": ["Heading fonts & colors", "white spaces symbols & Char set", "Entities & icons", "Video & Audio" ]
          },

          {
            "id":"5",
            "moduleTitle": "Forms",
            "moduleSubtitle": [ "Forms Attributes", "Get & Post", "Form labels & inputs", "Form input types" ]
          },

          {
            "id":"6",
            "moduleTitle": "Projects",
            "moduleSubtitle": [ "Contact Forms", "Groceries list", "Portfolio design"]
          },
        ]
      },

      {
  
        "id": "CSS",
        "courseTitle": "CSS",
        "CourseModule":[
          {
            "id":"CSS-1",
            "moduleTitle": "Introduction to CSS",
            // "moduleSubTitle": ["Introduction to Web", "Getting started with HTML", "Document Structure", "Element Tags & Attributes", "Creating New Page"],
            "moduleSubtitle": ["Where does CSS live?", "CSS syntax", "Variable and cascading in CSS", "Css Class's & ID", "Inline and block level elements" ]
          },

          {
            "id":"CSS-2",
            "moduleTitle": "Box Models & Typography",
            "moduleSubtitle": ["Margin Padding & border", "Width  & height", "Fonts colors, & Background color", "Line height Letter spacing , font style, font weight and White space" ]
          },

          {
            "id":"CSS-3",
            "moduleTitle": "Position & Display",
            // "moduleSubTitle": ["Heading fonts & colors", "white spaces symbols & Char set", "Entities & icons", "Video & Audio" ],
            "moduleSubtitle": ["Relative, Absolute, Static, Sticky & Fixed", "Display:Block, Inline-block, none, inline", "Display grid" ]
          },

          {
            "id":"CSS-4",
            "moduleTitle": "FlexBox in CSS",
            "moduleSubtitle": [ "Flex propertiese", "Flex basis", "Grow & Shrink", "Flex Wrap" ]
          },

          {
            "id":"CSS-5",
            "moduleTitle": "Responsiveness with Media Queries",
            "moduleSubtitle": ["Various of Tablet + Mobile Breakpoints"]
          },
          {
            "id":"CSS-6",
            "moduleTitle": "Miscellaneous",
            "moduleSubtitle": ["Float, Clear, Overflow, visibility, Pseudo Elements & Pseudo classes" , "Animations in CSS"]
          },
          {
            "id":"CSS-7",
            "moduleTitle": "Project",
            "moduleSubtitle": [ " Styling of Contact Forms", "Styling of Groceries list", "Styling of Portfolio design"]
          },
        ]
      },

      {
  
        "id": "javaScript",
        "courseTitle": "javaScript",
        "CourseModule":[
          {
            "id":"js-1",
            "moduleTitle": "Introduction to javaScript",
            "moduleSubtitle": ["Where does javaScript live?", "javaScript syntax", "DOM, comments and  variable in JS", "Targetting DOM element by various JS syntax", "JS operators" ]
          },

          {
            "id":"js-2",
            "moduleTitle": "Data Types & Function",
            "moduleSubtitle": ["The Concept of Data Types", "Various kind of data types in JS ", "Function in JS", "Data Types & Function" ]
          },
          {
            "id":"js-3",
            "moduleTitle": "Condition & Loops in JS",
            "moduleSubtitle": ["If condition", "If-else & If-else ladder","For, while, do-while & Switch", "Excerise on Conditional programming & Loops" ]
          },
          {
            "id":"js-4",
            "moduleTitle": "Array & String",
            "moduleSubtitle": ["Array methods like(filter(), sort() & map())", "String Method like (Split(), join() & replace())", "Excerise on Array and String methods" ]
          },

          {
            "id":"js-5",
            "moduleTitle": "Project 1",
            "moduleSubtitle": [ "Contact form validation", "Custom event list generator "]
          },

          {
            "id":"js-6",
            "moduleTitle": "Advance Javascript",
            "moduleSubtitle": ["ES6+", "Scoping", "Hoisting", "Clousers"]
          },
          {
            "id":"js-7",
            "moduleTitle": "Higher Order function in JS",
            "moduleSubtitle": ["Prototypes", "Call, Apply & bind" , "Classes & Objects in JS"]
          },

          {
            "id":"js-8",
            "moduleTitle": "JS-Async & HTTP call Handling",
            "moduleSubtitle": [ "JSON","Call backs", "Asynchronous JS", "Promises & Async-Await"]
          },

          {
            "id":"js-9",
            "moduleTitle": "Miscellaneous",
            "moduleSubtitle": [ "BOM(Browser object modal)","Math(), max(), min() & random()", "JS Dates", "Writing clean and maintainable codes", "Dimensions ","Basic Of JS testing"]
          },

          {
            "id":"js-10",
            "moduleTitle": "Project",
            "moduleSubtitle": [ " Making Slider from scratch","JS Hanging Game", "Custom Video player"]
          },
        ]
      },

      {
  
        "id": "React",
        "courseTitle": "React",
        "CourseModule":[
          {
            "id":"react-1",
            "moduleTitle": "Introduction to React.js",
            "moduleSubtitle": ["Why React.js?","Where does React.js live?", "Advantages and disadvantages of React.js" , "Installing React from Create-react-app", "File structure Explanation"]
          },

          {
            "id":"react-2",
            "moduleTitle": "Prerequist of courses",
            "moduleSubtitle": ["Strong understanding of javaScript", " ES6 ", "Basic of HTML", "Basic of CSS" ]
          },
          {
            "id":"react-3",
            "moduleTitle": "JSX (javaScript XML)",
            "moduleSubtitle": ["JSX syntax and javaScript", "JSX syntax and HTML","JSX Attributes", "Nested JSX element", "Multiple JSX expression", "Embedding javaScript in JSX" ]
          },
          {
            "id":"react-4",
            "moduleTitle": "Writting your first Component",
            "moduleSubtitle": ["Introduction to Class based component","Props, super() this.props and introduction to State", "React component base element", "Importing React", "render() & ReactDOM.render()","Render method in React" ]
          },

          {
            "id":"react-5",
            "moduleTitle": "Component Interaction & Reusable component in React",
            "moduleSubtitle": [ "Convertiing class based component to functional component", " Passing data with props ", "state handling in functional component", "Styling of react component"]
          },

          {
            "id":"react-6",
            "moduleTitle": "Advance React.js",
            "moduleSubtitle": ["Revision of Advance javaScript", "Introduction to React HOOKS(useState(), useEffect(), useRef() and more...)", "Fetch Data from JSON file", "Fetch Data using fetch api" , "Introduction to AXIOS"]
          },
          {
            "id":"react-7",
            "moduleTitle": "React Form handelling & UI libraries in React",
            "moduleSubtitle": ["Setting states for various input types", "Form validation" , "React materialize library"]
          },

          {
            "id":"react-8",
            "moduleTitle": "Miscellaneous",
            "moduleSubtitle": [ "Virtual DOM","Custom Hooks", "Conditional Rendring in React", " Handling form data with Firebase"]
          },

          {
            "id":"react-9",
            "moduleTitle": "Project",
            "moduleSubtitle": [ " React Website ","Receipe Maker App", "Meme Generater", "Live portfolio with firebase"]
          },
        ]
      }
    ]


